import React, { useState } from "react";
import CheckoutCard from "./CheckoutCard";
import CheckoutPIX from "./CheckoutPIX";
import { Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';
  
const CheckoutMP = () => {
  const [paymentType, setPaymentType] = useState(""); // "" | "card" | "pix"
  
  return (
    <div className="content-wrapper">
      <h3>Checkout Mercado Pago</h3>
        <Breadcrumb style={{ marginBottom: 16 }}>
            <Breadcrumb.Item>
                <Link to="/">Início</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
                <Link onClick={() => setPaymentType("")}>Api Mercado Pago</Link>
            </Breadcrumb.Item>
        </Breadcrumb>

      {!paymentType && (
        <div>
          <h3>Escolha o tipo de pagamento:</h3>
          <button onClick={() => setPaymentType("card")} style={{ marginRight: 10 }}>
            Cartão
          </button>
          <button onClick={() => setPaymentType("pix")}>PIX</button>
        </div>
      )}

      {paymentType === "card" && <CheckoutCard />}
      {paymentType === "pix" && <CheckoutPIX />}
    </div>
  );
};

export default CheckoutMP;
